import {Component, OnInit, OnDestroy} from '@angular/core';
import {MessageService} from '../message.service';
import {NotifierService} from 'angular-notifier';
import {Formatters} from 'angular-slickgrid';
import {RestApiService} from '../rest-api.service';
import {Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Subscription} from 'rxjs';
import {CustomInputEditor} from '../custom-inputEditor';
import {TypeofExpr} from "@angular/compiler";

@Component({
  selector: 'app-csat-master',
  templateUrl: './csat-master.component.html',
  styleUrls: ['./csat-master.component.css']
})
export class CsatMasterComponent implements OnInit, OnDestroy {
    show: boolean;
    dataset: any[];
    totalData: number;
    respObject: any;
    rating: any;
    ratingValue: any;


    displayData: any;

    add = false;
    del = false;
    edit = false;
    view = false;

    isError = false;
    errorMessage: string;
    newRatingValue: number;
    private notifier: NotifierService;
    private clientId: number;
    nextOffset: number;
    previousOffset: number;
    pageSize: number;
    paginationType: string;
    page_no: number;
    totalPage: number;
    private baseFlag: any;
    private userAuth: Subscription;
    offset: number;
    radioChecked: number;
    dataLoaded:boolean;
    constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
                private modalService: NgbModal, notifier: NotifierService) {
        this.notifier = notifier;
        this.messageService.getCellChangeData().subscribe(item => {
            switch (item.type) {
                case 'change':
                    console.log('changed');
                    if (!this.messageService.edit) {
                        this.notifier.notify('error', 'You do not have edit permission');
                    } else {
                        if (confirm('Are you sure?')) {
                            item.createdBy = this.messageService.getUserId();
                            this._rest.editCsatRating(item).subscribe((res) => {
                                this.respObject = res;
                                if (this.respObject.success) {
                                    // console.log('data--Done');
                                    this.notifier.notify('success', 'Updated successfully');
                                } else {
                                    // console.log('data--Not---Done');
                                    this.notifier.notify('error', this.respObject.errorMessage);
                                }
                            }, (err) => {
                                this.notifier.notify('error', JSON.stringify(err));
                            });
                        }
                    }
                    break;
                case 'delete':
                    // console.log('deleted');
                    if (!this.messageService.del) {
                        this.notifier.notify('error', 'You do not have delete permission');
                    } else {
                        if (confirm('Are you sure?')) {
                            this._rest.deleteCsatRating({id: item.id, user_id: this.messageService.getUserId()}).subscribe((res) => {
                                this.respObject = res;
                                if (this.respObject.success) {
                                    // this.totalData = this.totalData - 1;
                                    // this.messageService.setTotalData(this.totalData);
                                    this.messageService.sendAfterDelete(item.id);
                                } else {
                                    this.notifier.notify('error', this.respObject.errorMessage);
                                }
                            }, (err) => {
                                this.notifier.notify('error', this.respObject.errorMessage);
                            });
                        }
                    }
                    break;
            }
        });
    }

    ngOnInit() {
        this.dataLoaded=false;
        this.nextOffset = 0;
        this.previousOffset = 0;
        this.pageSize = this.messageService.pageSize;
        this.page_no = 0;
        this.totalPage = 0;
        this.paginationType = 'next';
        this.displayData = {
            pageName: 'Maintain CSAT Rating',
            openModalButton: ' Add CSAT Rating',
            breadcrumb: 'CSAT Rating',
            folderName: 'CSAT Rating',
            tabName: 'CSAT Rating'
        };
        const columnDefinitions = [
            {
                id: 'delete',
                field: 'id',
                excludeFromHeaderMenu: true,
                formatter: Formatters.deleteIcon,
                minWidth: 30,
                maxWidth: 30,
            },
            // {id: 'id', name: 'Id', field: 'id', sortable: true, filterable: true},
            {
                id: 'rating', name: 'Score Description', field: 'rating', sortable: true, filterable: true, cssClass: 'highlight',editor: {
                    model: CustomInputEditor,
                }
            },
            {
                id: 'value', name: 'Score', field: 'ratingValue', sortable: true, filterable: true,cssClass: 'highlight', editor: {
                    model: CustomInputEditor,
                }
            }
        ];
        this.messageService.setColumnDefinitions(columnDefinitions);
        if (this.messageService.clientId) {
            this.clientId = this.messageService.clientId;
            this.baseFlag = this.messageService.baseFlag;
            this.onPageLoad();
        } else {
            this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
                this.view = auth[0].viewFlag;
                this.add = auth[0].addFlag;
                this.edit = auth[0].editFlag;
                this.del = auth[0].deleteFlag;
                this.clientId = auth[0].clientId;
                this.baseFlag = auth[0].baseFlag;
                this.onPageLoad();
            });
        }
    }

    onPageLoad() {
        this.getTableData();
    }

    getTableData() {
        if (!this.messageService.view) {
            this.notifier.notify('error', 'You do not have view permission');
        } else {
            this.getData({'offset': this.nextOffset, 'paginationType': ''});
        }
    }

    isEmpty(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }
    changeRouting(path: string) {
        this.messageService.changeRouting(path);
    }


    openModal(content) {
        if (!this.messageService.add) {
            this.notifier.notify('error', 'You do not have add permission');
        } else {
            this.isError = false;
            this.modalService.open(content, {size: 'sm'}).result.then((result) => {
            }, (reason) => {
            });
        }
    }

    save() {
        this.newRatingValue = Number(this.ratingValue);
        console.log(this.newRatingValue);
        if ( !isNaN(this.newRatingValue)) {
            console.log(typeof (this.newRatingValue));
            const data = {
                clientId: this.clientId,
                rating: this.rating,
                ratingValue: this.newRatingValue,
                createdBy: this.messageService.getUserId()
            };
            if (!this.messageService.isBlankField(data)) {
                console.log(JSON.stringify(data));
                this._rest.insertCsatRating(data).subscribe((res) => {
                    this.respObject = res;
                    if (this.respObject.success) {
                        this.isError = false;
                        const id = this.respObject.details;
                        this.messageService.setRow({
                            id: id,
                            rating: this.rating,
                            ratingValue: this.ratingValue
                        });
                        this.totalData = this.totalData + 1;
                        this.messageService.setTotalData(this.totalData);
                        if (this.totalData <= this.pageSize * this.page_no) {
                            this.offset = id;
                            this.nextOffset = 0;
                        } else {
                            this.nextOffset = this.offset;
                        }
                        this.rating = '';
                        this.ratingValue = '';
                    } else {
                        this.isError = true;
                        this.errorMessage = this.respObject.errorMessage;
                    }
                }, (err) => {
                    this.isError = true;
                    this.errorMessage = this.messageService.SERVER_ERROR;
                });
            } else {
                this.isError = true;
                this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
            }
        }   else {
            this.isError = true;
            this.errorMessage = this.messageService.RATING_ERROR_MSG;
        }
    }

    getData(paginationObj) {
        const offset = paginationObj.offset;
        const paginationType = paginationObj.paginationType;
        this.dataLoaded=false;
        this._rest.getCsatRating(this.clientId, offset, this.pageSize, paginationType).subscribe((res) => {
            this.respObject = res;
            this.executeResponse(this.respObject, offset, paginationType);
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
            this.dataLoaded=true;
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                const data = respObject.details.dataObj;
                this.nextOffset = respObject.details.nextOffset;
                this.offset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }

    onPageSizeChange(value: any) {
        this.page_no = 0;
        this.nextOffset = 0;
        this.pageSize = value;
        this.getData({'offset': this.nextOffset, 'paginationType': ''});
    }

    ngOnDestroy(): void {
        if (this.userAuth) {
            this.userAuth.unsubscribe();
        }
    }

}
